
export const customReactSelectStyles = {
    control: (base: any) => ({
      ...base,
      padding: "4px 10px",
      minHeight: "38px", 
      borderColor: "#ced4da", 
      boxShadow: "none",
      "&:hover": {
        borderColor: "#86b7fe", 
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "0px", 
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      padding: "0px",
    }),
     
  singleValue: (base: any) => ({
    ...base,
    color: "#9B9B9B",  
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected ? '#fff' : '#212529',  
    backgroundColor: state.isSelected ? '#0d6efd' : '#fff',  
  }),

 
  placeholder: (base: any) => ({
    ...base,
    color: "#9B9B9B",
  }),
  }


  export const tableHeaderStyles = {
    headCells: {
      style: {
         color: 'gray',              // Header text color
         fontSize: '13px',           // Optional: font size
      },
    },
  };

  